export type CpScore = { kind: "cp"; cp: number };
export type MateScore = { kind: "mate"; mate: number };
export type EngineScore = CpScore | MateScore;

const MATE_BASE = 100_000;

export function parseEngineScore(
  info: { scoreCp?: number; mate?: number | null } | undefined | null
): EngineScore | null {
  if (!info) return null;
  if (info.mate != null && Number.isFinite(info.mate)) {
    return { kind: "mate", mate: info.mate };
  }
  if (info.scoreCp != null && Number.isFinite(info.scoreCp)) {
    return { kind: "cp", cp: info.scoreCp };
  }
  return null;
}

/** Convert a score from the side-to-move's POV to White's POV. */
export function toWhitePov(score: EngineScore, sideToMove: "w" | "b"): EngineScore {
  if (sideToMove === "w") return score;
  if (score.kind === "cp") return { kind: "cp", cp: -score.cp };
  return { kind: "mate", mate: -score.mate };
}

export function scoreToComparable(score: EngineScore): number {
  if (score.kind === "cp") return score.cp;
  if (score.mate > 0) return MATE_BASE - score.mate;
  return -MATE_BASE - score.mate;
}

export function whitePovMate(score: EngineScore | null): number | null {
  if (!score || score.kind !== "mate") return null;
  return score.mate;
}

export function cpLossFromScores(before: EngineScore, after: EngineScore): number {
  return Math.max(0, Math.round(scoreToComparable(before) - scoreToComparable(after)));
}

const PIECE_CP: Record<string, number> = {
  P: 100,
  N: 320,
  B: 330,
  R: 500,
  Q: 900,
  p: -100,
  n: -320,
  b: -330,
  r: -500,
  q: -900,
};

export function whiteMaterialCp(fen: string): number {
  const board = fen.split(" ")[0] || "";
  let total = 0;
  for (const ch of board) {
    const value = PIECE_CP[ch];
    if (value) total += value;
  }
  return total;
}
